module.exports = {
  title: 'Short Description',
  context: {
    text: 'Praesent tempor blandit tempus. <a href="http://www.google.com/">Pellentesque</a> ac arcu ligula. Nullam cursus.',
  },
}